/**
 * Post Authentication Requests Redux Reducer
 */

import {
  clearPostAuthenticationRequests,
  IPostAuthenticationRequest,
  IPostAuthenticationRequestsState,
  PostAuthenticationRequest,
  PostAuthenticationRequestType,
  pushPostAuthenticationRequestCreateProject,
  pushPostAuthenticationRequestDownload,
  pushPostAuthenticationRequestJoinProject,
  pushPostAuthenticationRequestPage,
  recoverPostAuthenticationRequests,
} from '../actions/postAuthenticationRequests';

import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IPostAuthenticationRequestsState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const initialState: ReducerState = [];

const clearPostAuthenticationRequestsHandler: Handler = () => initialState;

const pushPostAuthenticationRequestHandler: Handler<IPostAuthenticationRequest> =
  (state, payload) => [...state, payload];

const pushAuthenticationRequestFactory =
  (requestType: PostAuthenticationRequestType): Handler<PostAuthenticationRequest> =>
  (state, payload) => {
    const {
      page,
      ...restPayload
    } = payload!;
    return pushPostAuthenticationRequestHandler(state, {
      requestedAt: DateTime.local().toISO(),
      requestType,
      page,
      payload: isEmpty(restPayload) ? undefined : restPayload,
    });
  };

const recoverPostAuthenticationRequestsHandler: Handler<IPostAuthenticationRequest[]> =
  (_, payload) => payload;

export default reducerWithInitialState(initialState)
  .case(pushPostAuthenticationRequestPage, pushAuthenticationRequestFactory('page'))
  .case(pushPostAuthenticationRequestDownload, pushAuthenticationRequestFactory('downloadTrack'))
  .case(pushPostAuthenticationRequestCreateProject, pushAuthenticationRequestFactory('createProject'))
  .case(pushPostAuthenticationRequestJoinProject, pushAuthenticationRequestFactory('joinProject'))
  .case(recoverPostAuthenticationRequests, recoverPostAuthenticationRequestsHandler)
  .case(clearPostAuthenticationRequests, clearPostAuthenticationRequestsHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/postAuthenticationRequests.ts